import { CloseCircleFilled, SearchOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { createStyles } from 'antd-style'
import { isEmpty } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { Input } from '@eastcoal/formily/components/Input'

import { useListingPickerStore } from '../Store/hooks/useStore'

const useStyles = createStyles(({ token, prefixCls }) => ({
  icon: {
    fontSize: token.fontSizeIcon,
    color: token.colorBorder,
    ['&:active']: {
      color: token.colorIcon
    },
    ['&:hover']: {
      color: token.colorIcon
    }
  },
  button: {
    padding: '0',
    height: 'auto'
  }
}))

export const ListingPickerHolder = () => {
  const { styles } = useStyles()
  const { toggleModalOpen, listingDetail, deletePickerListing } =
    useListingPickerStore(state =>
      pick(state, ['toggleModalOpen', 'listingDetail', 'deletePickerListing'])
    )

  const inputValue = isEmpty(listingDetail)
    ? undefined
    : `${listingDetail?.kindName}【${listingDetail?.code}】`

  return (
    <Input
      readOnly
      value={inputValue}
      suffix={
        inputValue ? (
          <Button
            className={styles.button}
            type='link'
            onClick={deletePickerListing}
          >
            <CloseCircleFilled className={styles.icon} />
          </Button>
        ) : (
          <Button
            className={styles.button}
            type='link'
            onClick={toggleModalOpen}
          >
            <SearchOutlined className={styles.icon} />
          </Button>
        )
      }
      onClick={toggleModalOpen}
    />
  )
}
